import { useNavigate } from 'react-router-dom';

import {
  gridSizeMdLg6,
  ipv4FormSchema,
  ROUTER_PATHS,
  // useCheckPermissionsArray,
} from '@/shared';
import {
  CreateIpv4Params,
  useCreateIpv4,
  useFetchContratos,
  useFetchIpv4Groups,
  useUpdateIpv4,
} from '@/shared/actions/erp';
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomTextField,
  SingleFormBoxScene,
  SwitchComponenteForm,
} from '@/shared/components/ui';
import {
  AlertSeverityEnum,
  Contrato,
  EstadoIpv4Choices,
  Ipv4Extended,
  Ipv4Group,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
// import { SAVE_RADIUS_PERMISSIONS } from '../../constants';


export interface SaveIPV4ComponentProps {
  title: string;
  ipv4?: Ipv4Extended;
}

type SaveFormData = CreateIpv4Params & {
};

const SaveIPV4Component: React.FC<SaveIPV4ComponentProps> = ({ title, ipv4 }) => {
  // useCheckPermissionsArray(SAVE_RADIUS_PERMISSIONS);

  const returnUrlIpv4Page = ROUTER_PATHS.configuracionRED.ipv4Nav;
  const navigate = useNavigate();

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(ipv4FormSchema as any),
    defaultValues: {
      estado:true,
      // latitud: "0",
      // longitud: "0",
      // coordenadas: ipv4?.coordenadas ?? '0,0'
    }
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = form;


  ///* store
  const setAlert = useUiStore(s => s.setAlert);


  // const watchedZona = form.watch('zona');
  // const watchedCiudad = form.watch('ciudad');
  
  // const {
  //   setLatLng,
  //   setCurrentCoordenadas,
  // } = useMapComponent({
  //   form,
  //   currentCity: watchedCiudad,
  //   distanciaNapKey: 'distancia_aproximada',
  //   coordenadasCliente: ipv4?.nodo_data?.coordenadas ?? '',
  // });

  const {
    data:GruposIpv4Data,
    isLoading:isLoadingGruposIpv4
  } = useFetchIpv4Groups({
    page_size:1000
  },true)

  const {
    data:ContratosOptions,
    isLoading:isLoadingContratosOptions
  } = useFetchContratos({
    enabled:true,
    params:{
      page_size:20
    }
  })



  ///* mutations
  const createIpv4 = useCreateIpv4({
    navigate,
    returnUrl: returnUrlIpv4Page,
  });
  const updateIpv4 = useUpdateIpv4({
    navigate,
    returnUrl: returnUrlIpv4Page,
  });


  useEffect(() => {

    if (!ipv4) return;

    reset(ipv4)

  }, [ipv4])


  ///* handlers
  const onSave = async (data: SaveFormData) => {

    ///* update
    if (ipv4) {
      await updateIpv4.mutateAsync({
        id: ipv4.id_ipv4!,
        data: {
          ...data,
        },
      });
      return;
    }

    ///* create
    await createIpv4.mutateAsync(data);
  };



  return (
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => navigate(returnUrlIpv4Page)}
      onSave={handleSubmit(onSave, (errors) => {
        Object.values(errors).forEach(error => {
          setAlert(true, error.message || 'Verifique que los datos estén correctamente ingresados.', AlertSeverityEnum.error)
        })
        console.log({errors});
      })}
    >

      <CustomAutocomplete<Ipv4Group>
        label="Grupo IPV4"
        name="grupo_ipv4"
        //// options
        options={GruposIpv4Data?.data.data || []}
        // label & search by name
        valueKey="ipv_4"
        actualValueKey="codigo"
        //
        defaultValue={ ipv4?.grupo_ipv4|| form.getValues()?.grupo_ipv4 || ""}
        isLoadingData={isLoadingGruposIpv4}
        //// validation
        control={form.control}
        error={errors.grupo_ipv4}
        helperText={errors.grupo_ipv4?.message}
        size={gridSizeMdLg6}
      />
      
      <CustomAutocompleteArrString
        name='estado_ip'
        label='Estado IPV4'
        options={EstadoIpv4Choices}
        defaultValue={form.getValues()?.estado_ip as string}
        isLoadingData={false}
        error={errors.estado_ip}
        helperText={errors.estado_ip?.message}
        control={form.control}
        size={gridSizeMdLg6}
      />

      <CustomTextField
        label="Dirección IP"
        name="ip"
        control={form.control}
        defaultValue={ipv4?.ip||form.getValues()?.ip}
        error={errors.ip}
        helperText={errors.ip?.message}
        type="ipv4"
      // size={gridSizeMdLg6}
      />
      
      <SwitchComponenteForm
        label={form.watch()?.estado ? 'Activo' : 'Inactivo'}
        size={gridSizeMdLg6}
        control={form.control}
        defaultValue={!!form.getValues()?.estado}
        name="estado"
      />
      <CustomAutocomplete<Contrato>
        label="Servicio"
        name="contrato"
        //// options
        options={ContratosOptions?.data.data || []}
        // label & search by name
        valueKey="codigo"
        actualValueKey="codigo"
        //
        defaultValue={ ipv4?.contrato|| form.getValues()?.contrato || ""}
        isLoadingData={isLoadingContratosOptions}
        //// validation
        control={form.control}
        error={errors.grupo_ipv4}
        helperText={errors.grupo_ipv4?.message}
        size={gridSizeMdLg6}
        required={false}
      />


    </SingleFormBoxScene>
  );
};

export default SaveIPV4Component;
